import * as React from 'react';
import { FC } from 'react';

interface SchemaProducs {
  brand?: string;
  logo?: string;
  name?: string;
  category?: [
    {
      text?: string;
    }
  ];
  image?: [
    {
      url?: string;
    }
  ];
  description?: string;
}

const SchemaProduct: FC<SchemaProducs> = (props) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
  };

  if (props.brand) {
    Object.assign(structuredData, { brand: props.brand });
  }

  if (props.logo) {
    Object.assign(structuredData, { logo: props.logo });
  }

  if (props.name) {
    Object.assign(structuredData, { name: props.name });
  }

  if (props.category) {
    Object.assign(structuredData, { category: props.category[0].text });
  }

  if (props.image) {
    Object.assign(structuredData, { image: props.image[0].url });
  }

  if (props.description) {
    Object.assign(structuredData, { description: props.description });
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
};
export default SchemaProduct;
